import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.5247 4.44658L19.6228 3.73145L21.538 9.33301H23V20.9997H1V9.33301H2.65206L14.3468 -0.00878906L17.5247 4.44658ZM15.5485 5.12017L13.945 2.87198L7.84218 7.74689L15.5485 5.12017ZM16.7927 6.80909L9.38792 9.33301H19.4243L18.3869 6.29882L16.7927 6.80909ZM5.28516 14.1638V16.1677H7.28906V14.1638H5.28516Z"}}]};

const PantoneFilled = Vue.extend<IconProps>({
  name: 'PantoneFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pantone-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PantoneFilled;
